import { BPIAM_API } from '@/constants/API';
import { request } from '@umijs/max';

export interface FixedAccountLoginParams {
  username: string;
  password: string;
}

export interface FixedAccountLoginResponse {
  status: number;
  message?: string;
  payload?: {
    id_token?: string;
  };
}

/** 使用账号和 MD5 密码获取 IAM 登录凭证。 */
export function authenticateFixedAccount(params: FixedAccountLoginParams) {
  return request<FixedAccountLoginResponse>(`${BPIAM_API}/authenticate2`, {
    method: 'POST',
    data: params,
  });
}
